/**
 * Required Fields Types
 *
 * Types for required fields validation results.
 * Required fields are declared via `isRequired: true` on each
 * BenefitDefinition in the LOC definitions (single source of truth).
 */

/**
 * Information about a single missing required field on a specific plan.
 */
export interface MissingField {
  /** The grid-format benefit key (e.g., "benefitAmountType") */
  fieldKey: string;
  /** Human-readable label from the benefit definition */
  label: string;
  /** Identifier of the benefit plan missing the field */
  planIdentifier: string;
  /** Optional display name of the plan */
  planName?: string;
}

/**
 * Result of validating required fields against coverage data.
 */
export interface RequiredFieldsValidationResult {
  /** Whether all required fields have valid values across all plans */
  isValid: boolean;
  /** List of fields that are missing values, with plan context */
  missingFields: MissingField[];
  /** Total number of required fields checked */
  totalRequired: number;
  /** Number of required fields that have valid values */
  totalFilled: number;
}

/** Empty validation result for when validation cannot be performed */
export const EMPTY_VALIDATION_RESULT: RequiredFieldsValidationResult = {
  isValid: true,
  missingFields: [],
  totalRequired: 0,
  totalFilled: 0,
};
